module.exports = __webpack_public_path__ + "img/flies.1c970c44.png";